import { createContext } from "react";

import { User } from "../types/types";

export interface UserContextInterface {
  user?: User;
  logout: () => void;
  refreshToken: () => void;
  _state: "known" | "unknown";
}

export const UserContext = createContext<UserContextInterface>({
  logout: () => null,
  _state: "unknown",
  refreshToken: () => null,
});
